import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import AbroadFAQBlockData from '../../../Models/Content/AbroadFAQBlockData';
import QuestionAnswerItemBlockData from '../../../Models/Content/QuestionAnswerItemBlockData';
import React, {useContext, useEffect, useState} from 'react';
import QuestionAnswerItemBlock from './QuestionAnswerItemBlock';
import useFadeIn from '../../Shared/UseFadeIn';
import {Container} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import {connect} from 'react-redux';
import {gaEvent} from '../../../utilities/analytics/tracking';
import gaParams from '../../../utilities/analytics/constants';

const mapStateToProps = (state) => {
  return {
    activeLobbyTab: state.cellcomAbroad.activeLobbyTab,
    abroadPackagesList: state.cellcomAbroad.abroadPackagesList,
    businessIndividual: state.cellcomAbroad.epiStyleInitializationData.businessIndividualLobby,
    otpData: state.cellcomAbroad.otpData,
  };
};

type StateProps = ReturnType<typeof mapStateToProps>;

const AbroadFAQBlock = ({
  data,
  activeLobbyTab,
  abroadPackagesList,
  businessIndividual,
  otpData,
  context,
}: ComponentProps<AbroadFAQBlockData> & StateProps) => {
  const {fadeClass, ref} = useFadeIn();

  const [items, setItems] = useState<QuestionAnswerItemBlockData[]>(null);

  let isBusiness = false;
  const search = 'עמוד תוצאות חיפוש';
  const lobby = 'עמוד לובי';

  const itemOnOpen = function () {};

  useEffect(() => {
    if (!data.faqContentArea?.expandedValue) return setItems(null);

    const items = data.faqContentArea.expandedValue as QuestionAnswerItemBlockData[];
    let filteredItmes = null;

    switch (activeLobbyTab) {
      case 'private':
        filteredItmes = items.filter((x) => x.isPrivate.value === true);
        break;
      case 'businessAccount':
        filteredItmes = items.filter((x) => x.isBusiness.value === true);
        isBusiness = true;
        break;
      case 'packageExists':
        filteredItmes = items.filter((x) => x.isMyAbroad.value === true);
        break;
      default:
        filteredItmes = items;
        break;
    }

    setItems(filteredItmes);
  }, [activeLobbyTab]);

  useEffect(() => {
    window.addEventListener('scroll', trackScrolling);

    return () => {
      window.removeEventListener('scroll', trackScrolling);
    };
  }, [activeLobbyTab, abroadPackagesList]);

  useEffect(() => {
    window.addEventListener('scroll', trackScrolling);

    function isBottom(el) {
      return el.getBoundingClientRect().bottom <= window.innerHeight;
    }

    return () => {
      window.removeEventListener('scroll', trackScrolling);
    };
  }, []);

  const trackScrolling = () => {
    const wrappedElement = document.getElementById('AbroadFAQBlock');
    if (isBottom(wrappedElement)) {
      if (activeLobbyTab == 'businessAccount') {
        if (otpData.validatedCostumerData?.isSeparatedSale) {
          gaEvent(gaParams.SEPARATED_FAQZONE_SHOW.category, gaParams.SEPARATED_FAQZONE_SHOW.eventType, abroadPackagesList ? search : lobby);
        } else {
          gaEvent('hul_sale_business', 'visibility_20', abroadPackagesList ? search : lobby);
        }
      } else {
        if (!businessIndividual) {
          gaEvent('hul_sale_private', 'visibility_12', abroadPackagesList ? search : lobby);
        }
      }

      window.removeEventListener('scroll', trackScrolling);
    }
  };

  function isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  }

  return (
    <div id='AbroadFAQBlock' className='AbroadFAQBlock'>
      <div className='div-separator'></div>
      <h2 dangerouslySetInnerHTML={{__html: data.title.value}}></h2>
      <h3>{data.subTitle.value}</h3>
      <Container>
        <div ref={ref} className={isBusiness ? null : fadeClass}>
          <div className='AbroadFAQBlock__items'>
            {items?.map((item, i) => (
              <QuestionAnswerItemBlock
                abroadPackagesList={abroadPackagesList}
                eCategory={i + 1}
                key={i}
                data={item}
                isBusiness={isBusiness}
                isSeparatedSale={otpData.validatedCostumerData?.isSeparatedSale}
                onOpen={itemOnOpen}
              />
            ))}
          </div>
        </div>
      </Container>
      <br />
    </div>
  );
};

export default connect(mapStateToProps)(AbroadFAQBlock);
